// Valeurs des paliers en centimes d'euros
// Paliers : 90-100€, puis tous les 50€ (140-150€, 190-200€, etc.)
export const STEP_CONFIG = {
  FIRST_STEP: 90_00,
  STEP_LENGTH: 50_00,
  STEP_RANGE: 10_00,
};

export const NOTIFICATION_COOLDOWN = 10 * 60 * 1000; // 10 minutes
